import { readPickerIds } from 'server/model/marketplace/product/pickerSelection';

type ProductIdentifier = { id: string; productId?: string | null };

export type ProductPageSelection<T extends ProductIdentifier = ProductIdentifier> = {
  productSelection?: unknown;
  subBrand?: boolean | null;
  subcategoryPageName?: string | null;
  productCategories?: {
    categoryName?: string | null;
    products?: T[];
  }[];
  productSubcategoryPages?: ProductPageSelection<T>[];
  subSubcategoryPages?: ProductPageSelection<T>[];
};

export const getProductPageEntries = <T extends ProductIdentifier>(
  page: ProductPageSelection<T>,
): { product: T; categoryName: string | null; subBrand: string | null }[] => {
  const own = (page.productCategories ?? []).flatMap((category) =>
    (category.products ?? []).map((product) => ({
      product,
      categoryName: category.categoryName ?? page.subcategoryPageName ?? null,
      subBrand: page.subBrand ? (page.subcategoryPageName ?? null) : null,
    })),
  );
  const children = readPickerIds(page.productSelection, 'pimProductIds').length
    ? []
    : [...(page.productSubcategoryPages ?? []), ...(page.subSubcategoryPages ?? [])].flatMap(
        (child) => getProductPageEntries(child),
      );
  const unique = new Map<string, (typeof own)[number]>();
  for (const entry of [...own, ...children]) {
    const key = entry.product.productId || entry.product.id;
    if (!unique.has(key)) unique.set(key, entry);
  }
  return [...unique.values()];
};
